export const colors = {
    defaultColor: '#ffffffcc',

    mainWhite: '#FFF',
    mainBlack: '#000',

    mainBlue: '#252250',
    lightBlue: '#5e84e277',

    mainRed: '#ff3333',
    lightRed: '#ff000055',

    mainGreen: '#33ff33',
    lightGreen: '#33ff3355',

    mainYellow: '#FFFF33',
    lightYellow: '#FFFF3355',

}